export type Language = 'en' | 'ru'

export const translations = {
  en: {
    nav: {
      features: 'Features',
      howItWorks: 'How It Works',
      comparison: 'Comparison',
      blog: 'Blog',
      faq: 'FAQ',
      start: 'Start Creating',
    },
    hero: {
      badge: 'AI Website Builder v2.0',
      title: 'AI Creates Turnkey Websites',
      subtitle:
        'From concept to deployed site in minutes. The worlds most advanced AI website builder handles design, code, and content.',
      cta: 'Start Creating Free',
      demo: 'Watch Demo',
      aiPrompt: 'Create a modern landing page for my startup',
      aiWorking: 'AI is building your site...',
      aiDone: 'Your site is ready!',
    },
    features: {
      title: 'Why Choose AI Builder',
      subtitle: 'The smartest way to build your online presence',
      quality: {
        title: 'High Quality',
        desc: 'Professional design standards and clean, semantic code generated by advanced AI models.',
      },
      fast: {
        title: 'Lightning Fast',
        desc: 'Get a complete website in minutes, not weeks. Instant changes and real-time preview.',
      },
      cheap: {
        title: 'Cost Effective',
        desc: 'Save thousands of dollars compared to traditional agencies. No hidden fees or hourly rates.',
      },
      beautiful: {
        title: 'Beautiful Design',
        desc: 'Stunning aesthetics that adapt to your brand. Modern, responsive, and accessible by default.',
      },
    },
    howItWorks: {
      title: 'How It Works',
      subtitle: 'From idea to launch in 4 simple steps',
      step1: 'Describe Task',
      step1Desc: 'Tell the AI what you want to build in plain language',
      step2: 'AI Creates Site',
      step2Desc: 'Our engine generates design, copy, and code instantly',
      step3: 'Edit with AI',
      step3Desc: 'Refine and customize simply by chatting with the AI',
      step4: 'Site Ready',
      step4Desc: 'Publish your site to the world with one click',
    },
    comparison: {
      title: 'AI Builder vs Traditional Studio',
      subtitle: 'See why thousands are switching to AI development',
      feature: 'Feature',
      studio: 'Web Studio',
      ai: 'AI Builder',
      rows: {
        time: { name: 'Time to Launch', studio: '2-8 Weeks', ai: '5 Minutes' },
        cost: { name: 'Cost', studio: '$2,000 - $10,000+', ai: 'From $0' },
        revisions: {
          name: 'Revisions',
          studio: 'Slow & Expensive',
          ai: 'Instant & Unlimited',
        },
        tech: {
          name: 'Tech Skills',
          studio: 'Not Required',
          ai: 'Not Required',
        },
        maintenance: {
          name: 'Maintenance',
          studio: 'Monthly Retainer',
          ai: 'Automated',
        },
        quality: {
          name: 'Code Quality',
          studio: 'Varies by Dev',
          ai: 'Consistently High',
        },
        scalability: { name: 'Scalability', studio: 'Complex', ai: 'Built-in' },
      },
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know about AI website building',
      q1: 'Can I use my own domain?',
      a1: 'Yes, you can connect any custom domain to your AI-generated website instantly.',
      q2: 'Is the code SEO friendly?',
      a2: 'Absolutely. Our AI generates semantic, optimized HTML that search engines love.',
      q3: 'Can I export the code?',
      a3: 'Yes, on our Pro plan you can export the full source code and host it anywhere.',
      q4: 'Do I need coding skills?',
      a4: 'None at all. You can build, edit, and publish entirely through our chat interface.',
    },
    blog: {
      title: 'AI Industry Insights',
      subtitle: 'Latest news and articles about AI web development',
      readMore: 'Read Article',
    },
    cta: {
      title: 'Ready to Build Your Dream Site?',
      subtitle: 'Join 50,000+ creators building the future of the web with AI.',
      button: 'Create Your Site Now',
      noCard: 'No credit card required',
      free: 'Free to start',
    },
  },
  ru: {
    nav: {
      features: 'Преимущества',
      howItWorks: 'Как это работает',
      comparison: 'Сравнение',
      blog: 'Блог',
      faq: 'FAQ',
      start: 'Создать сайт',
    },
    hero: {
      badge: 'AI Конструктор Сайтов v2.0',
      title: 'ИИ Создает Сайты Под Ключ',
      subtitle:
        'От идеи до готового сайта за минуты. Самый продвинутый ИИ конструктор берет на себя дизайн, код и контент.',
      cta: 'Создать Бесплатно',
      demo: 'Смотреть Демо',
      aiPrompt: 'Создай современный лендинг для стартапа',
      aiWorking: 'ИИ создает ваш сайт...',
      aiDone: 'Ваш сайт готов!',
    },
    features: {
      title: 'Почему Выбирают Наш ИИ',
      subtitle: 'Умный способ создать свое присутствие в интернете',
      quality: {
        title: 'Качественно',
        desc: 'Профессиональные стандарты дизайна и чистый семантический код, созданный передовыми моделями ИИ.',
      },
      fast: {
        title: 'Быстро',
        desc: 'Готовый сайт за минуты, а не недели. Мгновенные изменения и предпросмотр в реальном времени.',
      },
      cheap: {
        title: 'Дешево',
        desc: 'Экономьте тысячи долларов по сравнению с веб-студиями. Никаких скрытых платежей.',
      },
      beautiful: {
        title: 'Красиво',
        desc: 'Потрясающая эстетика, адаптирующаяся под ваш бренд. Современный, адаптивный дизайн по умолчанию.',
      },
    },
    howItWorks: {
      title: 'Как Это Работает',
      subtitle: 'От идеи до запуска за 4 простых шага',
      step1: 'Описал задачу',
      step1Desc: 'Расскажите ИИ, что вы хотите создать, простым языком',
      step2: 'AI создал сайт',
      step2Desc: 'Наш движок мгновенно генерирует дизайн, текст и код',
      step3: 'Отредактировал с AI',
      step3Desc: 'Улучшайте и настраивайте результат, просто общаясь с ИИ',
      step4: 'Ваш сайт готов',
      step4Desc: 'Опубликуйте свой сайт для всего мира одним кликом',
    },
    comparison: {
      title: 'ИИ Конструктор vs Веб-Студия',
      subtitle: 'Узнайте, почему тысячи людей переходят на ИИ разработку',
      feature: 'Характеристика',
      studio: 'Веб-Студия',
      ai: 'ИИ Конструктор',
      rows: {
        time: { name: 'Время запуска', studio: '2-8 Недель', ai: '5 Минут' },
        cost: { name: 'Стоимость', studio: '$2,000 - $10,000+', ai: 'От $0' },
        revisions: {
          name: 'Правки',
          studio: 'Долго и дорого',
          ai: 'Мгновенно и безлимитно',
        },
        tech: {
          name: 'Тех. навыки',
          studio: 'Не требуются',
          ai: 'Не требуются',
        },
        maintenance: {
          name: 'Поддержка',
          studio: 'Ежемесячная оплата',
          ai: 'Автоматическая',
        },
        quality: {
          name: 'Качество кода',
          studio: 'Зависит от разраба',
          ai: 'Стабильно высокое',
        },
        scalability: {
          name: 'Масштабируемость',
          studio: 'Сложно',
          ai: 'Встроена',
        },
      },
    },
    faq: {
      title: 'Часто Задаваемые Вопросы',
      subtitle: 'Все, что нужно знать о создании сайтов с ИИ',
      q1: 'Могу ли я использовать свой домен?',
      a1: 'Да, вы можете мгновенно подключить любой свой домен к сайту.',
      q2: 'Оптимизирован ли код для SEO?',
      a2: 'Абсолютно. Наш ИИ генерирует семантический, оптимизированный HTML, который любят поисковики.',
      q3: 'Могу ли я экспортировать код?',
      a3: 'Да, на тарифе Pro вы можете экспортировать полный исходный код и хостить его где угодно.',
      q4: 'Нужны ли навыки программирования?',
      a4: 'Вовсе нет. Вы можете создавать, редактировать и публиковать сайт полностью через чат.',
    },
    blog: {
      title: 'Новости Индустрии ИИ',
      subtitle: 'Последние статьи о веб-разработке с искусственным интеллектом',
      readMore: 'Читать статью',
    },
    cta: {
      title: 'Готовы Создать Сайт Мечты?',
      subtitle:
        'Присоединяйтесь к 50,000+ создателей, строящих будущее веба с ИИ.',
      button: 'Создать Сайт Сейчас',
      noCard: 'Карта не требуется',
      free: 'Бесплатный старт',
    },
  },
}
